// extracted by mini-css-extract-plugin
module.exports = {"partnersSettings":"tmKE6","defaultSelectionValue":"N6bMO","filtersWrapper":"mlNK4","partnersRadio":"BJnzR","partnersInput":"_0x2yo","partnersSelect":"HAr5j"};